import { render, staticRenderFns } from "./GlobalIndicatorsCategorySelector.vue?vue&type=template&id=a488e64a&scoped=true&"
import script from "./GlobalIndicatorsCategorySelector.vue?vue&type=script&lang=ts&"
export * from "./GlobalIndicatorsCategorySelector.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalIndicatorsCategorySelector.vue?vue&type=style&index=0&id=a488e64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a488e64a",
  null
  
)

export default component.exports